import React, { useEffect, useState } from "react";
import "./IndexPageLayout.css";

import useAuthStore from "../../Zustand/Store/useAuthStore";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../Components/Footer/Footer";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DateRangeIcon from "@mui/icons-material/DateRange";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import TodayIcon from "@mui/icons-material/Today";
import CategoryIcon from "@mui/icons-material/Category";
import FormatAlignLeftIcon from "@mui/icons-material/FormatAlignLeft";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import AddIcon from "@mui/icons-material/Add";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import LoginIcon from "@mui/icons-material/Login";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ApprovalIcon from "@mui/icons-material/Approval";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import BuildIcon from "@mui/icons-material/Build";
import PersonIcon from "@mui/icons-material/Person";

import {
  Box,
  CssBaseline,
  Drawer,
  AppBar,
  Toolbar,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  IconButton,
  useTheme,
  createTheme,
  ThemeProvider,
  MenuItem,
  Menu,
  Tooltip,
  Avatar,
  Badge,
  Popover,
} from "@mui/material";

import {
  Mail as MailIcon,
  Notifications as NotificationsIcon,
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  Menu as MenuIcon,
  Logout as LogoutIcon,
  Lock as LockIcon,
  Edit as EditIcon,
  Dashboard as DashboardIcon,
  CorporateFare as CorporateFareIcon,
  Business as BusinessIcon,
  AddLocationAlt as AddLocationAltIcon,
  Assignment as AssignmentIcon,
  Settings as SettingsIcon,
  Engineering as EngineeringIcon,
  Store as StoreIcon,
  Segment as SegmentIcon,
  AppRegistration as AppRegistrationIcon,
  Apartment as ApartmentIcon,
  FormatAlignJustify as FormatAlignJustifyIcon,
  Autorenew as AutorenewIcon,
  ExitToApp as ExitToAppIcon,
  VerifiedUser as VerifiedUserIcon,
  LocalPolice as LocalPoliceIcon,
  AccountCircleOutlined,
  PeopleAltOutlined,
} from "@mui/icons-material";

import Swal from "sweetalert2";
import axios from "axios";
import { MAIN_URL } from "../../Configurations/Urls";
import useEmployeeDataStore from "../../Zustand/Store/useEmployeeDataStore";
import { routes } from "../../Configurations/PermissionConfigrations";
import NotAllowed from "../../Exceptions/NotAllowed";
import usePermissionDataStore from "../../Zustand/Store/usePermissionDataStore";
import toast from "react-hot-toast";

export default function RouteProtector({ children }) {
  const [darkMode, setDarkMode] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [drawerWidth, setDrawerWidth] = useState(290);
  const [isResizing, setIsResizing] = useState(false);
  const { resetData } = useEmployeeDataStore();
  const { Permission, setPermission } = usePermissionDataStore();

  
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: darkMode ? "dark" : "light",
        },
      }),
    [darkMode]
  );

  const navigate = useNavigate();
  const location = useLocation();

  const [anchorElUser, setAnchorElUser] = useState(null);

  const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isResizing) {
        const newWidth = Math.min(Math.max(e.clientX, 75), 400);
        setDrawerWidth(newWidth);
      }
    };

    const handleMouseUp = () => {
      if (isResizing) setIsResizing(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isResizing]);

  const { logout, userData, setAccess, login , setMode } = useAuthStore();
  const access = userData?.role || "Admin";

  console.log("permission is ", Permission);



  const { isLoggedIn , mode} = useAuthStore();
  let [OpenTCode, setOpenTCode] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === "/") {
        setOpenTCode(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const [isAllowed, setisAllowed] = useState(true);

  useEffect(() => {
    const currentPath = location.pathname;
    localStorage.setItem("lastVisitedRoute", currentPath);

    if (currentPath && Permission.length > 0) {
      // alert("gugug")

      const basePath = currentPath.includes("/edit")
        ? `${currentPath.split("/edit")[0]}/edit`
        : currentPath;

      const matchedRoute = routes.find((item) => item.name === basePath);
      console.log("match", matchedRoute);
      if (!matchedRoute) {
        //   alert("hjhhd")
        setisAllowed(true);
      } else if (
        matchedRoute.action &&
        Permission.includes(matchedRoute?.action)
      ) {
        // alert("jghughugd")

        console.log("basePath ", basePath);
        console.log("matchedRoute ", matchedRoute);

        setisAllowed(true);
      } else {
        setisAllowed(false);
      }
      console.log("Matched route is", matchedRoute);
    }
  }, [location, Permission]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const lastVisitedRoute = localStorage.getItem("lastVisitedRoute");
    if (!token) {
      navigate("/login"); return
      return;
    }

    axios
      .get(`${MAIN_URL}/api/auth/token-login`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { user } = response.data;

        setAccess(user?.role?.system_role_name);
        login(user);

        let dd = user.organization.find(
          (item) =>
            item.organization_id ==
            user.user_active_organization.organization_id
        );

        let mm = {
          ...user,
          organization: dd,
        };
        login(mm);

        // set auto login

          if(user?.loginuser[0]?.intern_code != undefined)
      {
        setMode(2);
      }
      
        console.log("users daya ios ", user);
        if (
        user?.user_active_organization?.settings?.setting_value === "self" &&
        user?.user_active_organization?.settings?.default_value === "self"
      ) {
        const item = {
          organization_id:
            user?.user_active_organization?.organization?.organization_id,
          organization_name:
            user?.user_active_organization?.organization?.organization_name,

          [user?.loginuser[0]?.intern_code == undefined
            ? "employee_id"
            : "intern_id"]:
            user.loginuser[0][
              user?.loginuser[0]?.intern_code == undefined
                ? "employee_id"
                : "intern_id"
            ],

          employee_details: user.loginuser[0],
        };

        // filter the employee  with the item.email   and pased to /
        console.log(
          "email is ",
          user?.user_active_organization?.application_user?.email
        );

        navigate("/", { state: item });
      }
  
  //else {

  //        // navigate("/organization-toggle");

  //       const item = {
  //   organization_id:
  //     user?.user_active_organization?.organization?.organization_id,
  //   organization_name:
  //     user?.user_active_organization?.organization?.organization_name,

  //   [user?.loginuser[0]?.intern_code == undefined
  //     ? "employee_id"
  //     : "intern_id"]:
  //     user.loginuser[0][
  //       user?.loginuser[0]?.intern_code == undefined
  //         ? "employee_id"
  //         : "intern_id"
  //     ],

  //   employee_details: user.loginuser[0],
  // };

  // // EMPLOYEE OR INTERN → set mode
  // setMode(
  //   user?.loginuser[0]?.intern_code !== undefined ? 2 : 1
  // );

  // navigate("/organization-toggle", { state: item }); 

       
  //     }


      })
      .catch((error) => {


        console.log("error in token login", error);
        navigate("/login"); return
      });
  }, []);

  useEffect(() => {
    const currentPath = location.pathname;
    if (
      currentPath === "/organization/employee/employee-details/add" ||
      currentPath === "/organization/employee/employee-details"
    ) {
      resetData();
    }
  }, [location.pathname]);

  console.log("users data is ", userData);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        const res = await axios.get(
          `${MAIN_URL}/api/user/${userData?.metadata?.[0]?.organization_user_id}/has-access`
        );
        console.log("repon", res);
        setPermission(res?.data?.allowed_actions);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          toast.error("Session Expired!");
          window.location.href = "/login";
        }
        console.error("Permission check error:", error);
      }
    };
    checkPermission();
  }, [userData?.metadata?.[0]?.organization_user_id]);

  // 🔐 Route-based Access Control
  const currentPath = location.pathname;
  console.log("current path is sikjs", currentPath);

  // Protect Employees Page from Admins
  if (access === "Admin" && currentPath === "/sidebar-option-page-1") {
    return <Navigate to="/" replace />;
  }

  // Protect Admin-only page from Users
  if (!isAllowed) {
    return <NotAllowed />;
  }

  // console.log("axcess", access);
  // console.log("userdata", userData);

  return (
    children
  
  );
}
